// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iziToast-wrapper {
    max-height: calc(67px * 3) !important;
    overflow: hidden;
    margin-top: 2rem;
    right: 0;
    text-align: right !important;
    padding: 10px 15px !important;
}
`, "",{"version":3,"sources":["webpack://./assets/stylesheets/toasts.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;IACR,4BAA4B;IAC5B,6BAA6B;AACjC","sourcesContent":[".iziToast-wrapper {\n    max-height: calc(67px * 3) !important;\n    overflow: hidden;\n    margin-top: 2rem;\n    right: 0;\n    text-align: right !important;\n    padding: 10px 15px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
